export const galleryImages = [
  // Upcoming Projects
  {
    id: 1,
    // title: '1',
    // projectName: 'Fainex lux Aer Resort',
    projectStatus: 'upcoming',
    image: '/images/gallery/upcomingandongoing/3.jpeg',
    // description: 'A Luxury Home stay in Vagamon suspended in the clouds, featuring infinity pools, spa, and panoramic valley views.',
    // type: 'Main Entrance'
  },
  // {
  //   // id: 2,
  //   // title: 'The Soul Resort',
  //   // projectName: 'The Soul Resort',
  //   // projectStatus: 'upcoming',
  //   // image: '/images/gallery/upcomingandongoing/4.jpeg',
  //   // description: 'An exclusive 20-acre estate with 6 pavilions, private lake, and helipad access.',
  //   // type: 'Private Lake View'
  // },
  // {
  //   id: 3,
  //   // title: 'The Soul Resort',
  //   // projectName: 'The Soul Resort',
  //   projectStatus: 'upcoming',
  //   image: '/images/gallery/upcomingandongoing/5.jpeg',
  //   // description: 'An exclusive 20-acre estate with 6 pavilions, private lake, and helipad access.',
  //   // type: 'Private Lake View'
  // },
  // {
  //   id: 4,
  //   // title: 'The Soul Resort',
  //   // projectName: 'The Soul Resort',
  //   projectStatus: 'upcoming',
  //   image: '/images/gallery/upcomingandongoing/6.jpeg',
  //   // description: 'An exclusive 20-acre estate with 6 pavilions, private lake, and helipad access.',
  //   // type: 'Private Lake View'
  // },
  // {
  //   id: 5,
  //   // title: 'The Soul Resort',
  //   // projectName: 'The Soul Resort',
  //   projectStatus: 'upcoming',
  //   image: '/images/gallery/upcomingandongoing/7.jpeg',
  //   // description: 'An exclusive 20-acre estate with 6 pavilions, private lake, and helipad access.',
  //   // type: 'Private Lake View'
  // },
  // {
  //   id: 6,
  //   // title: 'The Soul Resort',
  //   // projectName: 'The Soul Resort',
  //   projectStatus: 'upcoming',
  //   image: '/images/gallery/upcomingandongoing/8.jpeg',
  //   // description: 'An exclusive 20-acre estate with 6 pavilions, private lake, and helipad access.',
  //   // type: 'Private Lake View'
  // },
  // {
  //   id: 7,
  //   // title: 'The Soul Resort',
  //   // projectName: 'The Soul Resort',
  //   projectStatus: 'upcoming',
  //   image: '/images/gallery/upcomingandongoing/9.jpeg',
  //   // description: 'An exclusive 20-acre estate with 6 pavilions, private lake, and helipad access.',
  //   // type: 'Private Lake View'
  // },
  {
    id: 8,
    // title: 'The Soul Resort',
    // projectName: 'The Soul Resort',
    projectStatus: 'upcoming',
    image: '/images/gallery/upcomingandongoing/10.jpeg',
    // description: 'An exclusive 20-acre estate with 6 pavilions, private lake, and helipad access.',
    // type: 'Private Lake View'
  },
  // {
  //   id: 9,
  //   // title: 'The Soul Resort',
  //   // projectName: 'The Soul Resort',
  //   projectStatus: 'upcoming',
  //   image: '/images/gallery/upcomingandongoing/11.jpeg',
  //   // description: 'An exclusive 20-acre estate with 6 pavilions, private lake, and helipad access.',
  //   // type: 'Private Lake View'
  // },
  {
    id: 10,
    // title: 'The Soul Resort',
    // projectName: 'The Soul Resort',
    projectStatus: 'upcoming',
    image: '/images/gallery/upcomingandongoing/12.jpeg',
    // description: 'An exclusive 20-acre estate with 6 pavilions, private lake, and helipad access.',
    // type: 'Private Lake View'
  },
  {
    id: 11,
    // title: 'The Soul Resort',
    // projectName: 'The Soul Resort',
    projectStatus: 'upcoming',
    image: '/images/gallery/upcomingandongoing/13.jpeg',
    // description: 'An exclusive 20-acre estate with 6 pavilions, private lake, and helipad access.',
    // type: 'Private Lake View'
  },

  // Ongoing Projects
  {
    id: 13,
    // title: 'Kings Landing',
    // projectName: 'Kings Landing',
    projectStatus: 'ongoing',
    image: '/images/gallery/upcomingandongoing/o1.jpeg',
    // description: 'A private luxury boutique villa in Vagamon featuring valley views, an infinity pool, and curated dining.',
    // type: 'Dining Area'
  },
  {
    id:14,
    // title: 'The Highlanders',
    // projectName: 'The Highlanders',
    projectStatus: 'ongoing',
    image: '/images/gallery/upcomingandongoing/o2.jpeg',
    // description: 'A premium Vagamon retreat offering luxury stays, spa experiences, and scenic hill views.',
    // type: 'Main Building'
  },
  {
    id: 15,
    // title: 'The Highlanders',
    // projectName: 'The Highlanders',
    projectStatus: 'ongoing',
    image: '/images/gallery/upcomingandongoing/o3.jpeg',
    // description: 'A premium Vagamon retreat offering luxury stays, spa experiences, and scenic hill views.',
    // type: 'Main Building'
  },
  {
    id: 16,
    // title: 'The Highlanders',
    // projectName: 'The Highlanders',
    projectStatus: 'ongoing',
    image: '/images/gallery/upcomingandongoing/o4.jpeg',
    // description: 'A premium Vagamon retreat offering luxury stays, spa experiences, and scenic hill views.',
    // type: 'Main Building'
  },
  {
    id: 17,
    // title: 'The Highlanders',
    // projectName: 'The Highlanders',
    projectStatus: 'ongoing',
    image: '/images/gallery/upcomingandongoing/o5.jpeg',
    // description: 'A premium Vagamon retreat offering luxury stays, spa experiences, and scenic hill views.',
    // type: 'Main Building'
  },
  {
    id: 18,
    // title: 'The Highlanders',
    // projectName: 'The Highlanders',
    projectStatus: 'ongoing',
    image: '/images/gallery/upcomingandongoing/o6.jpeg',
    // description: 'A premium Vagamon retreat offering luxury stays, spa experiences, and scenic hill views.',
    // type: 'Main Building'
  },
  {
    id: 19,
    // title: 'The Highlanders',
    // projectName: 'The Highlanders',
    projectStatus: 'ongoing',
    image: '/images/gallery/upcomingandongoing/o7.jpeg',
    // description: 'A premium Vagamon retreat offering luxury stays, spa experiences, and scenic hill views.',
    // type: 'Main Building'
  },
  {
    id: 20,
    // title: 'The Highlanders',
    // projectName: 'The Highlanders',
    projectStatus: 'ongoing',
    image: '/images/gallery/upcomingandongoing/o8.jpeg',
    // description: 'A premium Vagamon retreat offering luxury stays, spa experiences, and scenic hill views.',
    // type: 'Main Building'
  },
  {
    id: 21,
    // title: 'The Highlanders',
    // projectName: 'The Highlanders',
    projectStatus: 'ongoing',
    image: '/images/gallery/upcomingandongoing/o9.jpeg',
    // description: 'A premium Vagamon retreat offering luxury stays, spa experiences, and scenic hill views.',
    // type: 'Main Building'
  },
  {
    id: 22,
    // title: 'The Highlanders',
    // projectName: 'The Highlanders',
    projectStatus: 'ongoing',
    image: '/images/gallery/upcomingandongoing/o10.jpeg',
    // description: 'A premium Vagamon retreat offering luxury stays, spa experiences, and scenic hill views.',
    // type: 'Main Building'
  },
  {
    id: 23,
    // title: 'The Highlanders',
    // projectName: 'The Highlanders',
    projectStatus: 'ongoing',
    image: '/images/gallery/upcomingandongoing/o11.jpeg',
    // description: 'A premium Vagamon retreat offering luxury stays, spa experiences, and scenic hill views.',
    // type: 'Main Building'
  }
];